import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { GenericListView } from 'src/app/infrastructure/infrastructure-services/generics/genericlistview/generic-list-view';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { enumIncomingOutgoingPaymentDocumentList, enumIncomingOutgoingPaymentDocumentType } from 'src/app/infrastructure/infrastructure-services/common/common-enums';
import { SecurityService } from 'src/app/login-layout/Service/security.service';

@Component({
  selector: 'app-incoming-payment-list-view',
  templateUrl: './incoming-payment-list-view.component.html',
  styleUrls: ['./incoming-payment-list-view.component.css']
})
export class IncomingPaymentListViewComponent extends GenericListView<any>{

  displayedColumns: string[] = [ 'postingDate', 'branchName', 'docNum', 
  'customerVendorName', 'amount', 'action'];
   override active=true;
   apiString="";

  canAdd: boolean = true;
  canEdit: boolean = true;
  canView: boolean = true;
  isActiveMenu: boolean = true;

  checkMenuPermissions() {
    let securityService = new SecurityService();
    let permissions = securityService.getMenuPermissions(this.getFormSubTitle);

    this.canAdd = permissions.canAdd;
    this.canEdit = permissions.canEdit;
    this.canView = permissions.canView;
    this.isActiveMenu = permissions.isActive;
  }

constructor(agenericRepository: GenericService<any>, router: Router, public dialog: MatDialog,private activated: ActivatedRoute) {
  super(agenericRepository, router);


  this.activated.url.subscribe(data => {
    if (data[0].path == enumIncomingOutgoingPaymentDocumentList.IncomingPaymentList) {
      this.setFormTitle = "Sales";
       this.setFormSubTitle = 'Incoming Payment'
      this.apiString = "IncomingPayments/GetIncomingPaymentsListService";
    }
    else if (data[0].path == enumIncomingOutgoingPaymentDocumentList.OutgoingPaymentList) {
      this.setFormTitle = "Purchase";
      this.setFormSubTitle = 'Outgoing Payment'
      this.apiString = "OutgoingPayments/GetOutgoingPaymentsListService";
    }
  });
  this.setObjectType = this.activated.snapshot.data['ObjType'];
  if (this.getObjectType == enumIncomingOutgoingPaymentDocumentType.IncomingPayment) {
    this.setFormSubTitle = 'Incoming Payment'
    this.setEntryFormRouteTo = "/home/sales/incomingPaymentEntryForm/";
  }
  else if (this.getObjectType == enumIncomingOutgoingPaymentDocumentType.OutgoingPayment) {
    this.setFormSubTitle = 'Outgoing Payment'
    this.setEntryFormRouteTo = "/home/sales/outgoingPaymentEntryForm/";
  }  
  this.checkMenuPermissions();

  this.setListViewDataSourceURL = `${this.apiString}`;
  // this.setFormTitle = "This is Form Title";
  // this.setFormSubTitle = "This is Sub Title of the Form.";
  // this.setMenuCode = "";
  // this.setEntryFormRouteTo = "/home/settings/projectmasterentryform/";
  // this.setListViewDataSourceURL = "IncomingPayments/GetIncomingPaymentsListService";
  // this.setEntryFormRouteTo = "/home/sales/incomingPaymentEntryForm/";
  this.setDisplayedColumnsNamesList = ['select', 'postingDate', 'branchName', 'docNum',
    'customerVendorName', 'amount', 'action'];
  this.getRequestData.SortColumn = "docDate";
  this.getRequestData.IsAcending=false;    
  this.PopulateListView();
  

}

}
